import LoginForm from "./LoginForm";
import LandingPageBackground from "components/utils/LandingPageBackground";
import MainWindow from "components/utils/MainWindow";
import { usePlatform } from "components/utils/PlatformContext";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { validateClient } from "services/authRequests";

const Login: React.FC = () => {
  // Get the platform context
  const { platform, privacyPolicyUrl, termsOfUseUrl, supportUrl, st4sBadge } =
    usePlatform();

  // Navigate hook
  const navigate = useNavigate();

  /**
   * Checks if there is an access or refresh token
   */
  useEffect(() => {
    validateClient().then((validateResponse) => {
      // Check if the user is connected
      if (validateResponse.connected) {
        // Redirect to the home page
        navigate("/home");
      }
    });
  }, []);

  return (
    <LandingPageBackground>
      <MainWindow>
        <div className="min-w-[300px] max-w-[414px] w-full self-stretch flex-col justify-start items-center gap-8 inline-flex">
          <div className="self-stretch h-fit flex-col justify-start items-start gap-6 flex">
            <div
              role="main"
              className="self-stretch justify-start items-center gap-2 inline-flex"
            >
              <h1 className="grow shrink basis-0 text-neutral-700 text-3xl font-semibold font-sans leading-[34px]">
                Sign in to your account
              </h1>
            </div>
            <div className="self-stretch justify-start items-center gap-2 inline-flex">
              <div className="grow shrink basis-0 text-neutral-700 text-base font-normal font-sans leading-[21px]">
                Welcome back! Sign in to access your account
              </div>
            </div>
          </div>
          <LoginForm />
          {platform === "codeflix" && (
            <div className="w-full justify-start items-start gap-2 inline-flex">
              <div className="text-neutral-700 text-sm font-normal font-sans leading-[17px]">
                Don't have an account?
              </div>
              <Link to="/sign-up">
                <div className="text-neutral-700 hover:text-neutral-900 text-sm font-semibold font-sans underline leading-[17px]">
                  Find out how to sign up
                </div>
              </Link>
            </div>
          )}
        </div>
        {/* Show the links just if there is a ST4S badge available */}
        {st4sBadge && (
          <div className="self-stretch inline-flex gap-10 items-center justify-center">
            {supportUrl && (
              <Link
                to={supportUrl}
                target="_blank"
                className="self-stretch text-neutral-700 text-base font-semibold font-sans leading-7 underline hover:text-neutral-900"
              >
                Support
              </Link>
            )}
            {privacyPolicyUrl && (
              <Link
                to={privacyPolicyUrl}
                target="_blank"
                className="self-stretch text-neutral-700 text-base font-semibold font-sans leading-7 underline hover:text-neutral-900"
              >
                Privacy policy
              </Link>
            )}
            {termsOfUseUrl && (
              <Link
                to={termsOfUseUrl}
                target="_blank"
                className="self-stretch text-neutral-700 text-base font-semibold font-sans leading-7 underline hover:text-neutral-900"
              >
                Terms of use
              </Link>
            )}
          </div>
        )}
      </MainWindow>
    </LandingPageBackground>
  );
};

export default Login;
